import { serviceAgreementApi } from 'api';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';

export const getServiceAgreementApi = async (
  serviceAgreementUid?: string,
  processInstanceId?: string | null,
): Promise<ServiceAgreementV2> => {
  return await serviceAgreementApi.getServiceAgreement({
    serviceAgreementUid,
    processInstanceId: processInstanceId ?? undefined,
  });
};
